export const navPanelWidth = '150px';
